import { FC, useMemo } from 'react';
import Container from 'src/components/atoms/Container';
import { DataTable } from 'src/components/organisms/DataTable/DataTable';
import { TableWrapper } from 'src/components/styled/TableWrapper';
import { useStores } from 'src/hooks/store-selection/queries/useStores';
import { useVat } from 'src/hooks/turnover/useVat';
import { calculateGrossMarginPercent } from 'src/utils/gross-margin/calculateGrossMargin';
import { calculateSummary } from '../calculateSummary';
import { createTotalBoldRowStyle, defaultColDef, storeSalesSummaryColumns } from '../data/columns';
import { SummaryReportProps } from '../types';
export const StoreSalesSummaryTab: FC<SummaryReportProps> = ({ salesCampaignRows, salesCampaignRowsByStore }) => {
    const { data } = useStores();
    const vat = useVat();

    const summaryRows = useMemo(() => {
        const rows = Object.entries(salesCampaignRowsByStore ?? {}).map(([storeId, rows]) => {
            const store = data?.allStores.find((store) => store.id.toString() === storeId);

            const summaryData = calculateSummary(rows);
            const grossMarginPercent = calculateGrossMarginPercent(
                summaryData.totalSalesPriceOnSale,
                summaryData.totalCogsOnSale,
                vat
            );

            return {
                id: store?.id ?? -1,
                storeName: store?.storeName ?? 'Unknown',
                ...summaryData,
                grossMarginPercent,
            };
        });

        const totalSummary = calculateSummary(salesCampaignRows);
        const totalGM = calculateGrossMarginPercent(
            totalSummary.totalSalesPriceOnSale,
            totalSummary.totalCogsOnSale,
            vat
        );

        return [
            ...rows,
            {
                id: 'total',
                storeName: 'Total',
                ...totalSummary,
                grossMarginPercent: totalGM,
            },
        ];
    }, [data?.allStores, salesCampaignRowsByStore, salesCampaignRows, vat]);

    return (
        <Container>
            <TableWrapper className="ag-theme-alpine-custom-compact small-font" sx={{ flex: 1 }}>
                <DataTable
                    {...createTotalBoldRowStyle('storeName')}
                    autoSizeToFit
                    rows={summaryRows}
                    columns={storeSalesSummaryColumns}
                    defaultColDef={defaultColDef}
                />
            </TableWrapper>
        </Container>
    );
};
